<template>
  <GlobalWindow :title="title" :visible.sync="visible" :confirm-working="isWorking" @confirm="confirm">
    <el-form :model="form" ref="form" :rules="rules">
      <el-form-item label="模板配置ID" prop="templateConfigId"><el-input v-model="form.templateConfigId" placeholder="模板配置ID" /></el-form-item>
      <el-form-item label="组件标识" prop="componentKey"><el-input v-model="form.componentKey" placeholder="组件标识" /></el-form-item>
      <el-form-item label="名称" prop="componentName"><el-input v-model="form.componentName" placeholder="名称" /></el-form-item>
      <el-form-item label="排序" prop="sortOrder"><el-input v-model="form.sortOrder" placeholder="排序" /></el-form-item>
      <el-form-item label="可见" prop="isVisible"><el-select v-model="form.isVisible" placeholder="可见">
        <el-option label="可见" value="1" />
        <el-option label="隐藏" value="0" />
      </el-select></el-form-item>
    </el-form>
  </GlobalWindow>
</template>
<script>
import BaseOpera from '@/components/base/BaseOpera'
import GlobalWindow from '@/components/common/GlobalWindow'
export default {
  name: 'operatemplateComponentWindow', extends: BaseOpera, components: { GlobalWindow },
  data() { return { form: { id: null, templateConfigId: '', componentKey: '', componentName: '', sortOrder: 0, isVisible: '1' }, rules: {} } },
  created() { this.config({ api: '/rentHouse/templateComponent', 'field.id': 'id' }) }
}
</script>